















































































import { Component } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'

@Component({
  data() {
    return {
      searchPubList: null,
      pubTree: [],
      pubTreeItems: [
        {
          id: 0,
          name: '공통화 작업 완료',
          author: 'ssyauu580',
          children: [
            {
              id: 1,
              name: '공통 UI 컴포넌트 가이드',
              to: '/publish/cm/completed',
              duedate: '2021-06-11',
              complete: '',
              author: 'unknown',
            },
          ],
        },

        {
          id: 1,
          name: '공통',
          children: [
            {
              id: 11,
              name: '공통 UI 컴포넌트 가이드',
              to: '/publish/cm/hh-po-cm-gp-001',
              duedate: '2021-06-11',
              complete: '',
              author: 'unknown',
            },
            // {
            //   id: 12,
            //   name: '페이지 레이아웃 가이드',
            //   to: '/publish/cm/hh-po-cm-gp-002',
            //   duedate: '2021-06-11',
            //   complete: '',
            //   author: 'unknown',
            // },
            // {
            //   id: 13,
            //   name: 'App bar',
            //   to: '/publish/cm/hh-po-cm-gp-003',
            //   duedate: '2021-06-11',
            //   complete: '',
            //   author: 'unknown',
            // },
            // {
            //   id: 14,
            //   name: 'GNB (Right drawer)',
            //   to: '/publish/cm/hh-po-cm-gp-004',
            //   duedate: '2021-06-11',
            //   complete: '',
            //   author: 'unknown',
            // },
            // {
            //   id: 15,
            //   name: '메뉴검색',
            //   to: '/publish/cm/hh-po-cm-gp-005',
            //   duedate: '2021-06-11',
            //   complete: '',
            //   author: 'unknown',
            // },
            {
              id: 16,
              name: '커스텀 디자인 아이콘 테이블',
              to: '/publish/cm/hh-po-cm-gp-006',
              duedate: '2021-06-11',
              complete: '',
              author: 'unknown',
            },
            // {
            //   id: 17,
            //   name: '설정',
            //   to: '/publish/cm/hh-po-cm-007',
            //   duedate: '2021-06-11',
            //   complete: '',
            //   author: 'unknown',
            // },
            // {
            //   id: 18,
            //   name: '오픈소스 라이센스',
            //   to: '/publish/cm/hh-po-cm-008',
            //   duedate: '2021-06-11',
            //   complete: '',
            //   author: 'unknown',
            // },
            // {
            //   id: 19,
            //   name: '도메인 전환',
            //   to: '/publish/cm/hh-po-cm-009',
            //   duedate: '2021-06-11',
            //   complete: '',
            //   author: 'unknown',
            // },
            // {
            //   id: 110,
            //   name: '알림설정',
            //   to: '/publish/cm/hh-po-cm-010',
            //   duedate: '2021-06-11',
            //   complete: '',
            //   author: 'unknown',
            // },
            // {
            //   id: 111,
            //   name: '알림(PUSH)내역',
            //   to: '/publish/cm/hh-po-cm-011',
            //   duedate: '2021-06-11',
            //   complete: '',
            //   author: 'unknown',
            // },
            {
              id: 112,
              name: '마이페이지',
              to: '/publish/cm/hh-po-cm-012',
              duedate: '2021-06-11',
              complete: '',
              author: 'unknown',
            },
            {
              id: 113,
              name: '사용자 정보 관리',
              to: '/publish/cm/hh-po-cm-013',
              duedate: '2021-06-11',
              complete: '',
              author: 'unknown',
            },
            // {
            //   id: 114,
            //   name: '비밀번호 변경',
            //   to: '/publish/cm/hh-po-cm-014',
            //   duedate: '2021-06-11',
            //   complete: '',
            //   author: 'unknown',
            // },
            {
              id: 111,
              name: '알림(PUSH)내역',
              to: '/publish/cm/hh-po-cm-011',
              duedate: '2021-06-11',
              complete: '2021-07-23',
              author: '김재섭',
            },
            {
              id: 115,
              name: '인증수단 관리',
              to: '/publish/cm/hh-po-cm-015',
              duedate: '2021-06-11',
              complete: '',
              author: 'unknown',
            },
            {
              id: 116,
              name: '협력사 선택',
              to: '/publish/cm/hh-po-cm-016',
              duedate: '2021-06-11',
              complete: '2021-07-19',
              author: '김재섭',
            },
            {
              id: 117,
              name: 'Wireframe',
              to: '/publish/cm/wireframe',
              duedate: '2021-06-11',
              complete: '',
              author: 'unknown',
            },
            {
              id: 118,
              name: 'Loading',
              to: '/publish/cm/loading',
              duedate: '2021-06-11',
              complete: '',
              author: 'unknown',
            },
            {
              id: 119,
              name: 'Markup',
              to: '/publish/cm/markup',
              duedate: '2021-06-11',
              complete: '',
              author: 'unknown',
            },
            {
              id: 120,
              name: '시간선택',
              to: '/publish/cm/timepicker',
              duedate: '2021-06-11',
              complete: '',
              author: 'unknown',
            },
            {
              id: 121,
              name: '파일업로드',
              to: '/publish/cm/ImageFileInput',
              duedate: '2021-08-03',
              complete: '2021-08-03',
              author: 'yyg',
            },
          ],
        },
        {
          id: 2,
          name: '로그인',
          children: [
            {
              id: 21,
              name: '로그인',
              to: '/publish/lg/hh-po-lg-001',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: '김재섭',
            },
            {
              id: 22,
              name: 'ID 찾기',
              to: '/publish/lg/hh-po-lg-002',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: '김재섭',
            },
            {
              id: 23,
              name: 'ID 찾기 완료',
              to: '/publish/lg/hh-po-lg-003',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: 'unknown',
            },
            {
              id: 24,
              name: '사용자 인증',
              to: '/publish/lg/hh-po-lg-004',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: '김재섭',
            },
            {
              id: 25,
              name: '사용자 인증 - 실패',
              to: '/publish/lg/hh-po-lg-005',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: '김재섭',
            },
            {
              id: 26,
              name: '오류 메세지 유형',
              to: '/publish/lg/hh-po-lg-005-case',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: '김재섭',
            },
            {
              id: 27,
              name: '인증 정보 등록',
              to: '/publish/lg/hh-po-lg-006',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: '김재섭',
            },
            {
              id: 28,
              name: '2차인증 - 휴대폰 인증',
              to: '/publish/lg/hh-po-lg-010',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: '김재섭',
            },
            {
              id: 211,
              name: '2차인증 - 생체 번호',
              to: '/publish/lg/hh-po-lg-011',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: '김재섭',
            },
            {
              id: 212,
              name: '토큰/세션 만료',
              to: '/publish/lg/hh-po-lg-012',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: '김재섭',
            },
            {
              id: 213,
              name: '비밀번호 찾기',
              to: '/publish/lg/hh-po-lg-013',
              duedate: '2021-06-09',
              complete: '2021-06-09',
              author: '김재섭',
            },
            {
              id: 214,
              name: '문의하기 등록',
              to: '/publish/lg/hh-po-lg-014',
              duedate: '2021-06-29',
              complete: '2021-07-02',
              author: '김재섭',
            },
            {
              id: 215,
              name: '문의 내역 보기',
              to: '/publish/lg/hh-po-lg-015',
              duedate: '2021-06-29',
              complete: '2021-07-02',
              author: '김재섭',
            },
            {
              id: 216,
              name: '답변 확인',
              to: '/publish/lg/hh-po-lg-016',
              duedate: '2021-06-29',
              complete: '2021-07-02',
              author: '김재섭',
            },
            {
              id: 217,
              name: '비밀번호 변경',
              to: '/publish/lg/hh-po-lg-017',
              duedate: '2021-06-29',
              complete: '2021-07-15',
              author: '김재섭',
            },
          ],
        },
        {
          id: 3,
          name: '메인',
          children: [
            {
              id: 31,
              name: '메인',
              to: '/publish/ma/hh-po-ma-001',
              duedate: '2021-07-13',
              complete: '',
              author: '김재섭',
            },
          ],
        },
        {
          id: 4,
          name: '상품관리',
          children: [
            {
              id: 41,
              name: '상품 조회/수정',
              to: '/publish/pm/hh-po-pm-001',
              duedate: '2021-06-28',
              complete: '2021-06-24',
              author: '김재섭',
            },
            {
              id: 42,
              name: '상품 수정',
              to: '/publish/pm/hh-po-pm-002',
              duedate: '2021-06-28',
              complete: '',
              author: '김재섭',
            },
            {
              id: 45,
              name: '출고/회수지 설정',
              to: '/publish/pm/hh-po-pm-005',
              duedate: '2021-06-28',
              complete: '2021-06-29',
              author: '김재섭',
            },
            {
              id: 46,
              name: '출고/회수지 설정 - 기존 주소',
              to: '/publish/pm/hh-po-pm-006',
              duedate: '2021-06-28',
              complete: '2021-06-29',
              author: '김재섭',
            },
            {
              id: 47,
              name: '주소검색',
              to: '/publish/pm/hh-po-pm-007',
              duedate: '2021-06-28',
              complete: '2021-06-30',
              author: '김재섭',
            },
            {
              id: 48,
              name: '상품 승인',
              to: '/publish/pm/hh-po-pm-008',
              duedate: '2021-06-28',
              complete: '2021-06-29',
              author: '김재섭',
            },
          ],
        },
        {
          id: 5,
          name: '물류관리',
          children: [
            {
              id: 51,
              name: '출고/회수 List - 출고 List',
              to: '/publish/lo/hh-po-lo-ta-001',
              duedate: '2021-06-16',
              complete: '2021-06-16',
              author: '김재섭',
            },
            {
              id: 54,
              name: '종합현황 - 출고 List',
              to: '/publish/lo/hh-po-lo-004',
              duedate: '2021-06-16',
              complete: '2021-06-16',
              author: '김재섭',
            },
            {
              id: 55,
              name: '출고 진행 상세',
              to: '/publish/lo/hh-po-lo-005',
              duedate: '2021-06-16',
              complete: '2021-06-16',
              author: '김재섭',
            },
            {
              id: 56,
              name: '출고/회수 List - 회수 List',
              to: '/publish/lo/hh-po-lo-ta-006',
              duedate: '2021-06-17',
              complete: '2021-06-17',
              author: '김재섭',
            },
            {
              id: 57,
              name: '종합현황 - 회수 List',
              to: '/publish/lo/hh-po-lo-007',
              duedate: '2021-06-17',
              complete: '2021-06-17',
              author: '김재섭',
            },
            {
              id: 58,
              name: '회수 진행 상세',
              to: '/publish/lo/hh-po-lo-008',
              duedate: '2021-06-17',
              complete: '2021-06-17',
              author: '김재섭',
            },
            {
              id: 59,
              name: '품절취소 등록/확인 - 품절취소등록',
              to: '/publish/lo/hh-po-lo-ta-009',
              duedate: '2021-06-17',
              complete: '2021-06-17',
              author: '김재섭',
            },
            {
              id: 511,
              name: '품절취소 등록/확인 - 등록내역확인',
              to: '/publish/lo/hh-po-lo-ta-011',
              duedate: '2021-06-17',
              complete: '2021-06-17',
              author: '김재섭',
            },
            {
              id: 512,
              name: '방송상품 공급계획 등록',
              to: '/publish/lo/hh-po-lo-012',
              duedate: '2021-06-17',
              complete: '2021-06-18',
              author: '김재섭',
            },
            {
              id: 513,
              name: '방송상품 공급계획 등록 상세',
              to: '/publish/lo/hh-po-lo-013',
              duedate: '2021-06-18',
              complete: '2021-06-18',
              author: '김재섭',
            },
            {
              id: 514,
              name: '입고요청 등록/현황 - 입고요청 List',
              to: '/publish/lo/hh-po-lo-014',
              duedate: '2021-06-18',
              complete: '2021-06-18',
              author: '김재섭',
            },
            {
              id: 515,
              name: '입고요청 등록/현황 - 입고현황 List',
              to: '/publish/lo/hh-po-lo-015',
              duedate: '2021-06-18',
              complete: '2021-06-18',
              author: '김재섭',
            },
            {
              id: 516,
              name: '입고요청 등록/현황 - 입고현황 상세',
              to: '/publish/lo/hh-po-lo-016',
              duedate: '2021-06-18',
              complete: '2021-06-18',
              author: '김재섭',
            },
            {
              id: 518,
              name: '재고현황(센터배송 상품)',
              to: '/publish/lo/hh-po-lo-018',
              duedate: '2021-06-18',
              complete: '2021-06-18',
              author: '김재섭',
            },
            {
              id: 519,
              name: '재고현황 상품별 상세',
              to: '/publish/lo/hh-po-lo-019',
              duedate: '2021-06-18',
              complete: '2021-06-18',
              author: '김재섭',
            },
          ],
        },
        {
          id: 6,
          name: '문의관리',
          children: [
            {
              id: 61,
              name: '상품 Q&A',
              to: '/publish/cs/hh-po-cs-001',
              duedate: '2021-07-08',
              complete: '2021-07-09',
              author: '김재섭',
            },
            {
              id: 62,
              name: '답변 유형 선택',
              to: '/publish/cs/hh-po-cs-002',
              duedate: '2021-07-08',
              complete: '2021-07-08',
              author: '김재섭',
            },
            {
              id: 63,
              name: 'CS문의',
              to: '/publish/cs/hh-po-cs-003',
              duedate: '2021-07-08',
              complete: '2021-07-08',
              author: '김재섭',
            },
            {
              id: 65,
              name: 'CS문의 답변',
              to: '/publish/cs/hh-po-cs-005',
              duedate: '2021-07-08',
              complete: '2021-07-08',
              author: '김재섭',
            },
            {
              id: 67,
              name: '드림CS',
              to: '/publish/cs/hh-po-cs-007',
              duedate: '2021-07-08',
              complete: '2021-07-08',
              author: '김재섭',
            },
            {
              id: 68,
              name: '드림CS 상세',
              to: '/publish/cs/hh-po-cs-008',
              duedate: '2021-07-08',
              complete: '2021-07-08',
              author: '김재섭',
            },
          ],
        },
        {
          id: 7,
          name: '방송관리',
          children: [
            {
              id: 71,
              name: 'ON-AIR 판매현황 - TV쇼핑',
              to: '/publish/br/hh-po-br-ta-001',
              duedate: '2021-06-23',
              complete: '2021-06-21',
              author: '김재섭',
            },
            {
              id: 72,
              name: 'TV쇼핑 - 속성별 현황',
              to: '/publish/br/hh-po-br-002',
              duedate: '2021-06-23',
              complete: '2021-06-21',
              author: '김재섭',
            },
            {
              id: 75,
              name: '방송결과 상세 - TV쇼핑',
              to: '/publish/br/hh-po-br-ta-005',
              duedate: '2021-06-23',
              complete: '2021-06-21',
              author: '김재섭',
            },
            {
              id: 77,
              name: '방송결과 상세 - 상품별 실적',
              to: '/publish/br/hh-po-br-007',
              duedate: '2021-06-23',
              complete: '2021-06-21',
              author: '김재섭',
            },
          ],
        },
        {
          id: 8,
          name: '실적/통계',
          children: [
            {
              id: 81,
              name: '실적/통계',
              to: '/publish/pe/hh-po-pe-001',
              duedate: '2021-07-09',
              complete: '',
              author: '김재섭',
            },
          ],
        },
        {
          id: 9,
          name: '정산',
          children: [
            {
              id: 91,
              name: '대금지불 내역',
              to: '/publish/ca/hh-po-ca-001',
              duedate: '2021-06-30',
              complete: '2021-06-30',
              author: '김재섭',
            },
            {
              id: 92,
              name: '대금지불 내역 상세 - 보류/입금',
              to: '/publish/ca/hh-po-ca-lu-002',
              duedate: '2021-06-30',
              complete: '2021-06-30',
              author: '김재섭',
            },
            {
              id: 93,
              name: '대금지불 내역 상세 - 공제/선지급',
              to: '/publish/ca/hh-po-ca-lu-003',
              duedate: '2021-06-30',
              complete: '2021-06-30',
              author: '김재섭',
            },
            {
              id: 94,
              name: '매출현황',
              to: '/publish/ca/hh-po-ca-004',
              duedate: '2021-06-30',
              complete: '2021-06-30',
              author: '김재섭',
            },
            {
              id: 95,
              name: '매입현황',
              to: '/publish/ca/hh-po-ca-005',
              duedate: '2021-06-30',
              complete: '2021-06-30',
              author: '김재섭',
            },
          ],
        },
        {
          id: 10,
          name: '오프라인',
          children: [
            {
              id: 101,
              name: '오프라인 매장 재고',
              to: '/publish/of/hh-po-of-001',
              duedate: '2021-07-02',
              complete: '2021-07-21',
              author: '김재섭',
            },
            {
              id: 102,
              name: '오프라인 재고 실사',
              to: '/publish/of/hh-po-of-002',
              duedate: '2021-07-02',
              complete: '2021-07-21',
              author: '김재섭',
            },
            {
              id: 103,
              name: '오프라인 반출 요청',
              to: '/publish/of/hh-po-of-003',
              duedate: '2021-07-02',
              complete: '2021-07-21',
              author: '김재섭',
            },
            {
              id: 104,
              name: '오프라인 반출 요청 상세',
              to: '/publish/of/hh-po-of-004',
              duedate: '2021-07-02',
              complete: '2021-07-21',
              author: '김재섭',
            },
            {
              id: 105,
              name: '오프라인 반출 의뢰 확정',
              to: '/publish/of/hh-po-of-005',
              duedate: '2021-07-02',
              complete: '2021-07-21',
              author: '김재섭',
            },
            {
              id: 107,
              name: '오프라인 반출 의뢰 상세',
              to: '/publish/of/hh-po-of-007',
              duedate: '2021-07-02',
              complete: '2021-07-21',
              author: '김재섭',
            },
            {
              id: 108,
              name: '오프라인 반출 요청 현황',
              to: '/publish/of/hh-po-of-008',
              duedate: '2021-07-02',
              complete: '2021-07-22',
              author: '김재섭',
            },
            {
              id: 110,
              name: '반출 의뢰 상세 - 반출확정',
              to: '/publish/of/hh-po-of-010',
              duedate: '2021-07-02',
              complete: '2021-07-22',
              author: '김재섭',
            },
            {
              id: 112,
              name: '반출 의뢰 상세 - 반출요청 취소',
              to: '/publish/of/hh-po-of-012',
              duedate: '2021-07-02',
              complete: '2021-07-22',
              author: '김재섭',
            },
            {
              id: 114,
              name: '오프라인 반출 현황',
              to: '/publish/of/hh-po-of-014',
              duedate: '2021-07-02',
              complete: '2021-07-22',
              author: '김재섭',
            },
            {
              id: 116,
              name: '반출 현황 상세',
              to: '/publish/of/hh-po-of-016',
              duedate: '2021-07-02',
              complete: '2021-07-22',
              author: '김재섭',
            },
          ],
        },
        {
          id: 12,
          name: '공지사항',
          children: [
            {
              id: 121,
              name: '공지사항 목록',
              to: '/publish/no/hh-po-no-001',
              duedate: '2021-06-10',
              complete: '2021-06-11',
              author: '김재섭',
            },
            {
              id: 122,
              name: '공지사항 상세',
              to: '/publish/no/hh-po-no-002',
              duedate: '2021-06-11',
              complete: '2021-06-11',
              author: '김재섭',
            },
          ],
        },
        {
          id: 13,
          name: '기타',
          children: [
            {
              id: 131,
              name: '문의하기 목록',
              to: '/publish/et/hh-po-et-001',
              duedate: '2021-07-07',
              complete: '2021-06-14',
              author: '김재섭',
            },
            {
              id: 132,
              name: '문의하기 등록',
              to: '/publish/et/hh-po-et-002',
              duedate: '2021-07-07',
              complete: '2021-06-14',
              author: '김재섭',
            },
            {
              id: 134,
              name: '답변 확인',
              to: '/publish/et/hh-po-et-004',
              duedate: '2021-07-07',
              complete: '2021-06-14',
              author: '김재섭',
            },
            {
              id: 135,
              name: '담당자 연락처',
              to: '/publish/et/hh-po-et-005',
              duedate: '2021-07-07',
              complete: '',
              author: '김재섭',
            },
            {
              id: 137,
              name: '교육신청',
              to: '/publish/et/hh-po-et-ta-007',
              duedate: '2021-07-07',
              complete: '2021-07-06',
              author: '김재섭',
            },
            {
              id: 138,
              name: '교육 신청 상세',
              to: '/publish/et/hh-po-et-008',
              duedate: '2021-07-07',
              complete: '2021-07-06',
              author: '김재섭',
            },
            {
              id: 139,
              name: '내 신청 내역',
              to: '/publish/et/hh-po-et-ta-009',
              duedate: '2021-07-07',
              complete: '2021-07-06',
              author: '김재섭',
            },
            {
              id: 1310,
              name: '내 신청 내역 상세',
              to: '/publish/et/hh-po-et-010',
              duedate: '2021-07-07',
              complete: '2021-07-06',
              author: '김재섭',
            },
          ],
        },
      ],
    }
  },
  methods: {
    statusPublish(due, complete) {
      if (complete !== '') {
        return 'success'
      } else {
        const now = new Date()
        const dueDate = new Date(due)
        if (now <= dueDate) {
          return 'grey lighten-1'
        } else {
          return 'warning'
        }
      }
    },
  },
  middleware: async (ctx) => {
    // todo: middleware
  },
  validate: async (ctx) => {
    // todo: validate
    return true
  },
  asyncData: async (ctx) => {
    // todo: asyncData
  },
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  // #region variables
  pubListSheet = false
  // #endregion
  // #region hooks
  // #endregion
  // #region methods
  onClickPageItem(path) {
    this.pubListSheet = false
    this.$router.push(path)
  }
  // #endregion
  // #region watches
  // #endregion
}
